import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AuthForgotPasswordRequestBody, AuthForgotPasswordResponse } from "./types";

export class ForgotPasswordAPI extends BaseAPI<
    AuthForgotPasswordRequestBody,
    AuthForgotPasswordResponse
> {
    protected route = ApiRoutes.auth.forgot_password;
    protected method = RequestMethod.POST;
}
